"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
export default function useQueryParams() {
  const $ = _c(9);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const queryParams = searchParams as unknown as Partial<T>;
  let t0;
  if ($[0] !== searchParams) {
    t0 = new URLSearchParams(searchParams);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const urlSearchParams = t0;
  let t1;
  if ($[2] !== pathname || $[3] !== router || $[4] !== urlSearchParams) {
    t1 = function setQueryParams(params) {
      Object.entries(params).forEach(t2 => {
        const [key, value] = t2;
        urlSearchParams.set(key, String(value));
      });
      const search = urlSearchParams.toString();
      const query = search ? `?${search}` : "";
      router.push(`${pathname}${query}`);
    };
    $[2] = pathname;
    $[3] = router;
    $[4] = urlSearchParams;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const setQueryParams = t1;
  let t2;
  if ($[6] !== queryParams || $[7] !== setQueryParams) {
    t2 = {
      queryParams,
      setQueryParams
    };
    $[6] = queryParams;
    $[7] = setQueryParams;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}